import React, { useState } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import geequipLOGO from '../../assets/Icone-png-16.png'
import { i18n } from '../../translate/i18n';
import { QrReader } from 'react-qr-reader';
import { makeStyles } from '@mui/styles';

import {
  AppBar,
  CssBaseline,
  Toolbar,
  Container,
  Typography
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import LanguageSelection from '../Login/components/LanguageSelection';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: 80,
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  appBar: {
    backgroundColor: 'green',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  },
}));

const QRCodeReader = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [readerError, setReaderError] = useState('');
  // const [facingMode, setFacingMode] = useState('environment') //environment -> back camera, user -> front camera

  const goToLogin = () => {
    props.history.push('/login');
  }

  const goToEquipmentsPublic = (result) => {
    try {
      let equipmentIdFromQrCode = '';
      if (result.text.includes('type')) {
        const qrCodeJson = JSON.parse(result.text);
        equipmentIdFromQrCode = qrCodeJson._id;
      } else {
        equipmentIdFromQrCode = result.text.split('/').at(-2);
      }
      if (equipmentIdFromQrCode.length === 24) return props.history.push(`/form-equip-public/${equipmentIdFromQrCode}`);
    } catch (e) {
      setReaderError(e.message)
    }
  }

  return (
    <div>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div style={styles.logoContainer}>
            <img src={geequipLOGO} style={styles.logo} />
            <div style={styles.titleContainer}>
              <Typography style={{ fontWeight: 'bold', fontSize: 22 }} className={classes.title} noWrap>ge</Typography>
              <Typography style={{ fontSize: 22 }}>equip</Typography>
            </div>
          </div>
          <LanguageSelection />
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} onClick={goToLogin}>
            <ArrowBack />
          </div>
          <div style={{ marginTop: 20 }}>
            <div style={styles.guidelineItem}>
              <span style={styles.number}>1</span> {i18n.t('qrcodeInstructions.access')}
            </div>
            <div style={styles.guidelineItem}>
              <span style={styles.number}>2</span> {i18n.t('qrcodeInstructions.network')}
            </div>
            <div style={styles.guidelineItem}>
              <span style={styles.number}>3</span> {i18n.t('qrcodeInstructions.point')}
            </div>
          </div>
          <div style={{ flex: 1, width: '100%', position: 'relative' }}>
            <QrReader
              constraints={{ facingMode: 'environment' }}
              onResult={(result, error) => {
                if (!!result) {
                  goToEquipmentsPublic(result)
                }
              }}
              style={{ width: '100%' }}
            />

          </div>
          <p>{readerError}</p>
        </div>
      </Container>
    </div>
  );
}

export default withRouter(QRCodeReader)

const styles = {
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: 36,
    marginRight: 10,
  },
  number: {
    backgroundColor: '#cecece',
    height: 40,
    width: 40,
    borderRadius: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 15
  },
  guidelineItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5
  }
}
